<template>
  <div>
    <header>
      <div class="wrap-menu-header gradient1 trans-0-4">
        <div class="container h-full">
          <div class="wrap_header trans-0-3">
            <div class="logo">
              <a href="/">
                <img
                  id="banner"
                  :src="headerImage"
                  alt="IMG-LOGO"
                  data-logofixed="/static/images/icons/logo2.png"
                >
              </a>
            </div>
            <div class="wrap_menu p-l-45 p-l-0-xl">
              <nav class="menu">
                <ul class="main_menu">
                  <li>
                    <router-link to="/">
                      {{ $t("column.home") }}
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/gallery">
                      {{ $t("column.gallery") }}
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/blog">
                      {{ $t("column.blog") }}
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/menu">
                      {{ $t("column.menu") }}
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/about">
                      {{ $t("column.about") }}
                    </router-link>
                  </li>

                  <li>
                    <div class="dropdownFlex">
                      <vue-dropdown
                        :config="config"
                        @setSelectedOption="setNewSelectedOption($event);"
                        style="margin-top: -18px;"
                      ></vue-dropdown>
                    </div>
                  </li>
                </ul>
              </nav>
            </div>
            <div class="header-fixed social flex-end">
              <a href="https://www.facebook.com/haihostel/" target="_blank" >
                <i class="fa fa-facebook m-l-21" aria-hidden="true"></i>
              </a>
              <a href="https://www.instagram.com/pataw_hostel/" target="_blank">
                <i class="fa fa-instagram m-l-21" aria-hidden="true"></i>
              </a>
              <button class="btn-show-sidebar m-l-33 trans-0-4"></button>
            </div>
          </div>
        </div>
      </div>
    </header>
    <aside class="sidebar trans-0-4">
      <button
        class="btn-hide-sidebar ti-close color0-hov trans-0-4"
        style="position: absolute;
                font-size: 20px;
                color: #111111;
                padding: 10px;
                top: 20px;
                right: 20px;"
      ></button>
      <ul class="menu-sidebar p-t-95 p-b-70">
        <li class="t-center m-b-13 btn-hide-sidebar">
          <router-link to="/">{{ $t("column.home") }}</router-link>
        </li>
        <li class="t-center m-b-13 btn-hide-sidebar">
          <router-link to="/gallery">{{ $t("column.gallery") }}</router-link>
        </li>
        <li class="t-center m-b-13 btn-hide-sidebar">
          <router-link to="/blog">{{ $t("column.blog") }}</router-link>
        </li>
        <li class="t-center m-b-13 btn-hide-sidebar">
          <router-link to="/menu">{{ $t("column.menu") }}</router-link>
        </li>
        <li class="t-center m-b-13 btn-hide-sidebar">
          <router-link to="/about">{{ $t("column.about") }}</router-link>
        </li>
      </ul>
      <!-- <div class="gallery-sidebar t-center p-l-60 p-r-60 p-b-40">
        <h4 class="txt20 m-b-33">INSTAGRAM</h4>
        <div class="wrap-gallery-sidebar flex-w">
          <a
            class="item-gallery-sidebar wrap-pic-w"
            v-bind:href="this.result[0].images.low_resolution.url"
            data-lightbox="gallery-footer"
          >
            <img v-bind:src="this.result[0].images.standard_resolution.url" alt="GALLERY">
          </a>

          <a
            class="item-gallery-sidebar wrap-pic-w"
            v-bind:href="this.result[1].images.low_resolution.url"
            data-lightbox="gallery-footer"
          >
            <img v-bind:src="this.result[1].images.standard_resolution.url" alt="GALLERY">
          </a>

          <a
            class="item-gallery-sidebar wrap-pic-w"
            v-bind:href="this.result[2].images.low_resolution.url"
            data-lightbox="gallery-footer"
          >
            <img v-bind:src="this.result[2].images.standard_resolution.url" alt="GALLERY">
          </a>

          <a
            class="item-gallery-sidebar wrap-pic-w"
            v-bind:href="this.result[3].images.low_resolution.url"
            data-lightbox="gallery-footer"
          >
            <img v-bind:src="this.result[3].images.standard_resolution.url" alt="GALLERY">
          </a>

          <a
            class="item-gallery-sidebar wrap-pic-w"
            v-bind:href="this.result[4].images.low_resolution.url"
            data-lightbox="gallery-footer"
          >
            <img v-bind:src="this.result[4].images.standard_resolution.url" alt="GALLERY">
          </a>

          <a
            class="item-gallery-sidebar wrap-pic-w"
            v-bind:href="this.result[5].images.low_resolution.url"
            data-lightbox="gallery-footer"
          >
            <img v-bind:src="this.result[5].images.standard_resolution.url" alt="GALLERY">
          </a>

          <a
            class="item-gallery-sidebar wrap-pic-w"
            v-bind:href="this.result[6].images.low_resolution.url"
            data-lightbox="gallery-footer"
          >
            <img v-bind:src="this.result[6].images.standard_resolution.url" alt="GALLERY">
          </a>

          <a
            class="item-gallery-sidebar wrap-pic-w"
            v-bind:href="this.result[7].images.low_resolution.url"
            data-lightbox="gallery-footer"
          >
            <img v-bind:src="this.result[7].images.standard_resolution.url" alt="GALLERY">
          </a>

          <a
            class="item-gallery-sidebar wrap-pic-w"
            v-bind:href="this.result[8].images.low_resolution.url"
            data-lightbox="gallery-footer"
          >
            <img v-bind:src="this.result[8].images.standard_resolution.url" alt="GALLERY">
          </a>
        </div> -->
      <!-- </div> -->
    </aside>
  </div>
</template>
<style scoped >
.router-link-exact-active{
text-decoration:none;
}
.btn-show-sidebar.m-l-33.trans-0-4 {
  display: none;
}
.dropdownFlex {
  position: fixed;
}
@media (max-width: 992px) {
  .btn-show-sidebar.m-l-33.trans-0-4 {
    display: inline-block;
  }
  .show-overlay-sidebar {
    visibility: hidden;
    background-color: rgba(0, 0, 0, 0.65);
  }
}
</style>
<script >
import vueDropdown from "../components/vue-dropdown/vue-dropdown";

export default {
  name: "Header",
  components: {
    vueDropdown
  },
  data() {
    return {
      result: 0,
      headerImage:"/static/images/icons/logo.png",
      la: navigator.language,
      config: {
        options: [
          {
            value: "繁體中文",
            img: "../static/images/taiwan.png",
            lang: "changeEn"
          },
          {
            value: "English",
            img: "/static/images/united-states.png",
            lang: "changeEn"
          },
          {
            value: "日本語",
            img: "/static/images/japan.png",
            lang: "changeEn"
          },
          {
            value: "Deutsch",
            img: "/static/images/germany.png",
            lang: "changeEn"
          },
          {
            value: "Français",
            img: "/static/images/france.png",
            lang: "changeEn"
          },
          {
            value: "ไทย",
            img: "/static/images/thailand.png",
            lang: "changeEn"
          }
        ],
        placeholder: "",
        backgroundColor: "#cde4f5",
        textColor: "black",
        borderRadius: "1.5em",
        border: "1px solid gray",
        width: 180
      }
    };
  },
  methods: {
    changeEn() {
      this.$i18n.locale = "en";
    },
    changeTw() {
      this.$i18n.locale = "zh-TW";
    },
    changeJa() {
      this.$i18n.locale = "ja";
    },
    changeDe() {
      this.$i18n.locale = "de";
    },
    changeFr() {
      this.$i18n.locale = "fr";
    },
    changeTh() {
      this.$i18n.locale = "th";
    },
    setNewSelectedOption(selectedOption) {
      this.config.placeholder = selectedOption.value;

      if (selectedOption.value == "繁體中文") {
        this.$i18n.locale = "zh-TW";
        $(".main_menu").find("li").css("margin-left", "10px")
      }
      if (selectedOption.value == "English") {
        this.$i18n.locale = "en";
        $(".main_menu").find("li").css("margin-left", "-10px")
      }
      if (selectedOption.value == "日本語") {
        this.$i18n.locale = "ja";
        $(".main_menu").find("li").css("margin-left", "-10px")
      }
      if (selectedOption.value == "Deutsch") {
        this.$i18n.locale = "de";
        $(".main_menu").find("li").css("margin-left", "-10px")
      }
      if (selectedOption.value == "Français") {
        this.$i18n.locale = "fr";
        $(".main_menu").find("li").css("margin-left", "-13px")
      }
      if (selectedOption.value == "ไทย") {
        this.$i18n.locale = "th";
        $(".main_menu").find("li").css("margin-left", "-10px")
      }
    }
  },
  created() {
    //
    //var getAuthUrl =
    //  "https://api.instagram.com/oauth/authorize/?client_id=	e2762c5ab4784e3a937716fa6e3d45da&redirect_uri=http://localhost:8081&response_type=token";
    // var accessToken =
    //   "?access_token=1505778998.16061ea.135c5f0f37ca4b5aac1470e8feb9d33f";
    // var xhr = new XMLHttpRequest();
    // xhr.addEventListener("readystatechange", function() {
    //   if (this.readyState === 4) {
    //     var response = JSON.parse(this.responseText);
    //     this.result = response;
    //   }
    // });
    // xhr.open(
    //   "GET",
    //   "https://api.instagram.com/v1/users/self/media/recent/" + accessToken,
    //   false
    // );
    // xhr.send();
    // this.result = JSON.parse(xhr.response);
    // this.result = this.result.data;

    if (navigator.language == "zh-TW") {
      this.config.placeholder = "繁體中文";
    }
    if (navigator.language == "en-US") {
      this.config.placeholder = "English";
    }
    if (navigator.language == "ja") {
      this.config.placeholder = "日本語";
    }
    if (navigator.language == "de") {
      this.config.placeholder = "Deutsch";
    }
    if (navigator.language == "fr") {
      this.config.placeholder = "Français";
    }
    if (navigator.language == "th") {
      this.config.placeholder = "ไทย";
    }
  }
};
</script>





// WEBPACK FOOTER //
// src/components/Header.vue